import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const BasicInfo = ({ data }) => {
    const horoscopeData = data || {};
    const { t } = useTranslation();
    // Prepare data as label-value pairs
    var d1 = moment.duration(horoscopeData.ayanamsa, 'minutes');
    var d2 = moment.duration(d1.asSeconds(), 'minutes');
    const ayanamsaFormated = moment({ m: d1.minutes() }).format('mm:') + moment({ m: d2.minutes(), s: d2.seconds() }).format('mm:ss');
    const ayanamsaValue = horoscopeData?.req?.type === 5 ? `${ayanamsaFormated}(KP)` : ayanamsaFormated;

    const items = [
        { name: t("Nekatha"), value: horoscopeData.nekatha + " / " + horoscopeData.nekathaPadaya },
        { name: t("Thithiya"), value: horoscopeData.thithiya },
        { name: t("Karanaya"), value: horoscopeData.karanaya },
        { name: t("Yogaya"), value: horoscopeData.yogaya },
        { name: t("Horawa"), value: horoscopeData.hora },
        { name: t("PHorawa"), value: horoscopeData.horaPanchama },
        { name: t("SHorawa"), value: horoscopeData.horaSukshama },
        //{ name: t("LAGNAYA"), value: horoscopeData.lagna },
        //{ name: t("NAWANSAKAYA"), value: horoscopeData.navamsaka },
        { name: t("SunRise"), value: horoscopeData.sunRise },
        { name: t("SunSet"), value: horoscopeData.sunSet },
        { name: t("Ayanamsa"), value: ayanamsaValue },
        { name: t("DASAWA"), value: horoscopeData.dasa[0]?.dasaL1 + ' ' + horoscopeData.dasa[0]?.duration },
        { name: t("NakTime"), value: horoscopeData.nakTime },
        { name: t("H60"), value: horoscopeData.h60 },
        { name: t("ShakaWarshaya"), value: horoscopeData.shakaWarshaya },
        { name: t("Derkana22nd"), value: horoscopeData.derkana22nd },
        { name: t("Fortuna"), value: horoscopeData.fortuna },
        { name: t("Yogakaraka"), value: horoscopeData.yogakaraka },
        { name: t("NawansakaAdipathi64th"), value: horoscopeData.nawansakaAdipathi64th },

        //new suya masa kramaya
    ];

    // Split items into rows of 3 columns each
    const rows = [];
    for (let i = 0; i < items.length; i += 3) {
        rows.push(items.slice(i, i + 3));
    }

    return (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px', marginBottom: '16px' }}>
            <tbody>
                {rows.map((row, idx) => (
                    <tr key={idx}>
                        {row.map((item, colIdx) => (
                            <React.Fragment key={colIdx}>
                                <td style={{fontSize: '12px', fontWeight: 'bold', padding: '2px 4px', whiteSpace: 'nowrap' }}>{item.name}</td>
                                <td style={{fontSize: '12px', padding: '2px 4px', whiteSpace: 'nowrap' }}>{item.value}</td>
                            </React.Fragment>
                        ))}
                        {/* Fill empty cells if row has less than 3 items */}
                        {row.length < 3 &&
                            Array.from({ length: 3 - row.length }).map((_, i) => (
                                <React.Fragment key={`empty-${i}`}>
                                    <td></td>
                                    <td></td>
                                </React.Fragment>
                            ))
                        }
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
BasicInfo.propTypes = {
    data: PropTypes.object.isRequired,
};
export default BasicInfo;